import React, { Children, useEffect, useState, useRef } from 'react'
import classes from "../Sigfox/SigFoxContentLayout.module.css";
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import RemoveCamectIcon from "../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/SensorIcons/trash.png"
import { deleteAjaxFromSite, removeAibox, unlinkDahua, unlinkHikvision, unlinkSigfoxAPI } from '../../../../../../Api Methods/Api';
import unavailable from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unavailable.png'
import confirmation from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/confirmation.png'
import Button1 from '../../../../Button/Button1';
import { add, format } from 'date-fns';
import { Button } from 'primereact/button';
import Lottie from 'lottie-react';
import areYouSureAnim from '../../../../../../assets/animations/areYouSure.json'
import successAnim from '../../../../../../assets/animations/success.json'
import { Dialog } from 'primereact/dialog';

const IntegrationContentLayout = ({ integration, pin, fetchVirtualSources, successVisible, setSuccessVisible }) => {
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);

    const integrationTitle = integration.integrationType
    const ID = integration.extraField1
    const pinName = pin.pinName

    const parsed = integration?.extraField2
        ? JSON.parse(integration.extraField2)
        : [];

    const zoneName = ` ${parsed?.[0]?.zoneName || ""}`;
    let isControllingType = parsed?.[0]?.controlLevel || ""
    if (isControllingType == "output_relay") isControllingType = "Relays"
        if (isControllingType == "channel") isControllingType = "Channels"
    const isControlling = parsed?.[0]?.ruleUUIDs || ""
    console.log(isControlling)

    const addedBy = integration.addedBy
    const dateAdded = integration.created_at


    console.log(integration)
    console.log(dateAdded)

    const apiData = {
        token,
        client
    }

    //------------------------------- Modal Logic  ----------------------------------------------
    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }

    const [modalTitle, setModalTitle] = useState("")
    const [modalComponent, setModalComponent] = useState()
    //--------------------------------------------------------------------------------------------
    const [modalPageIndex, setModalPageIndex] = useState(null);

    const [showAddCamect, setShowAddCamect] = useState(false);

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const HandelResetModal = () => {
        setShowAddCamect(null);
        setModalPageIndex(null);
    }

    const dispatch = useDispatch();
    const DeviceDetails = useSelector(state => state.service.DeviceDetails)

    const unlinkAIBOX = async () => {
        const responseData = await removeAibox(apiData, DeviceUUID, pin.Pin, dispatch)
        if (responseData) {
            HandleCloseModal();
            setSuccessVisible(true)
            fetchVirtualSources();
        }
    }

    const unlinkHik = async () => {
        const responseData = await unlinkHikvision(apiData, DeviceUUID, pin.Pin, dispatch)
        if (responseData) {
            HandleCloseModal();
            setSuccessVisible(true)
            fetchVirtualSources();
            //show success??
        }
    }

    const unlinkAjax = async (hubID) => {
        const responseData = await deleteAjaxFromSite(apiData, DeviceUUID, ID, dispatch)
        if (responseData){
            HandleCloseModal();
            setSuccessVisible(true)
            fetchVirtualSources();
        }
    }

    const UnlinkDahua = async () => {
        const responseData = await unlinkDahua(apiData, DeviceUUID, pin.Pin, dispatch)
        if (responseData) {
            HandleCloseModal();
            setSuccessVisible(true)
            fetchVirtualSources();
        }
    }

    const unlink = () => {
        if (integrationTitle == "AJAX"){
           setModalTitle("Are you sure?")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this Ajax hub?`}</h3>
                    <br />
                    <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => HandleCloseModal()} />
                    <br />
                    <Button label="Yes, unlink hub" rounded icon="pi pi-check" severity="danger" onClick={() => unlinkAjax()} />

                </div>
            )
            HandleShowModal();
        }
        else if (integrationTitle == "HIKVISION"){
           setModalTitle("Are you sure?")
            setModalComponent(

                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this Hikvision?`}</h3>
                    <br />
                    <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => HandleCloseModal()} />
                    <br />
                    <Button label="Yes, unlink hub" rounded icon="pi pi-check" severity="danger" onClick={() => unlinkHik()} />
                </div>
            )
            HandleShowModal();
        }
        else if (integrationTitle == "DAHUA"){
            setModalTitle("Are you sure?")
            setModalComponent(

                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this Dahua?`}</h3>
                    <br />
                    <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => HandleCloseModal()} />
                    <br />
                    <Button label="Yes, unlink" rounded icon="pi pi-check" severity="danger" onClick={() => UnlinkDahua()} />
                </div>
            )
            HandleShowModal();
        }
        else if (integrationTitle == "AIBOX"){
            console.log("here")
            //perform delete!
            setModalTitle("Are you sure?")
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <Lottie
                        animationData={areYouSureAnim}
                        loop={false}
                        style={{ width: 150, height: 150, margin: "0px" }}
                    />
                    <br />
                    <h3 style={{ color: "#6e6e6eff" }}>{`Are you sure you want to unlink this AIBOX?`}</h3>
                    <br />
                    <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => HandleCloseModal()} />
                    <br />
                    <Button label="Yes, unlink hub" rounded icon="pi pi-check" severity="danger" onClick={() => unlinkAIBOX()} />

                </div>
            )
            HandleShowModal();
        }
    }

    return (
        <>
            <Modal ref={ModalDialog} title={modalTitle} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "600px", minHeight: "270px" }} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>


            

            <div className={classes.IntegrationContentLayout} >
                <div className={classes["left-wrapper"]}>
                    <h3 className={classes.integrationTitle}>{`${integrationTitle}${zoneName}`}</h3>
                    <h3 className={classes.subtitle}>
                    {isControllingType !== "rule"
                        ? `${isControllingType} ${isControlling}`
                        : "Rules"}
                    </h3>                    
                    <p style={{fontSize: "13px", fontStyle:"bold", margin:"0px", maxWidth:"220px"}} className={classes.subtitle}>{ID}</p>

                    <div style={{display:"flex", flexDirection:"row", width:"100%", marginTop:"10px"}}>
                        { addedBy && <small style={{fontSize: "9px", fontStyle:"italic", marginTop: integrationTitle === "HIKVISION" || integrationTitle === "DAHUA" ? "10px" : "2px", maxWidth:"220px"}}>{`Added by ${addedBy.fullName} on ${format(new Date(dateAdded), "MMM do, yyyy")}`}</small>}
                    </div>
                    
                </div>

                <div className={classes["right-wrapper"]}>

                    <div className={classes["text-container"]} >
                        <h3 className={classes.pinName}>{pinName} </h3>
                    </div>

                    <div className={classes["Icons-Container"]} >
                        <img className={classes.Icon} src={RemoveCamectIcon} onClick={() => unlink()} />
                    </div>
                </div>
            </div >
            
        </>
    )
}

export default IntegrationContentLayout;




